export default __webpack_public_path__ + "static/media/language.d86d91d7.svg";